<template>
  <column-chart
    class="pa-4"
    :colors="['#ff6214']"
    :data="[
      ['Pending', pending],
      ['Submitted', submitted],
      ['Confirmed', confirmed],
      ['Completed', completed],
    ]"
  ></column-chart>
</template>

<script>
export default {
  name: "OrderBreakdownChart",
  props: {
    pending: {
      type: Number,
    },
    submitted: {
      type: Number,
    },
    confirmed: {
      type: Number,
    },
    completed: {
      type: Number,
    },
  },
};
</script>

<style scoped></style>
